// engine
import { ArContainer, ArSpine, ORIENTATION } from '@aceroll/core';

/*
    for simple using mockups, need to:
    - use base size of the game as a mockup image size
*/

export class Mockup extends ArContainer {
    lsMockups = [
        // ArSprite.from('img-mockup_main_landscape', 'mockup-main-landscape')
    ];
    ptMockups = [
        // ArSprite.from('img-mockup_main_portrait', 'mockup-main-portrait')
    ];

    constructor() {
        super('mockups');
    }

    setup() {
        for (const lsMockupSprite of this.lsMockups) {
            lsMockupSprite.anchor.set(0.5);

            const { width, height } = this.baseSize[ORIENTATION.LANDSCAPE];

            lsMockupSprite.position.set(width / 2, height / 2);
            lsMockupSprite.visible = false;

            this.addChild(lsMockupSprite);
        }

        for (const ptMockupSprite of this.ptMockups) {
            ptMockupSprite.anchor.set(0.5);

            const { width, height } = this.baseSize[ORIENTATION.PORTRAIT];

            ptMockupSprite.position.set(width / 2, height / 2);
            ptMockupSprite.visible = false;

            this.addChild(ptMockupSprite);
        }
        const spine = new ArSpine('spine-symbol_multiplier');
        // spine.setImmediately('firework',true);
        spine.y = 500;
        //DEBUG
        window.sp = spine;
        // const name = [
        //     '1_rocket_blue_high',
        //     '1_rocket_blue_mid_up',
        //     '1_rocket_blue_mid',
        //     '1_rocket_blue_mid_down',
        //     '1_rocket_blue_short',
        //     '1_rocket_blue_reel_eff',
        //
        //     '1_rocket_red_down',
        //     '1_rocket_red_high',
        //     '1_rocket_red_mid_up',
        //     '1_rocket_red_mid',
        //     '1_rocket_red_mid_down',
        //     '1_rocket_red_short',
        //     '1_rocket_red_eff',
        //
        //     '3_rockets',
        //     '3_rockets_eff',
        //
        //     '5_rockets',
        //     '5_rockets_eff',
        //
        //     'firework'
        // ]
        this.addChild(spine);
    }
}
